module.exports = __webpack_public_path__ + "img/bom-icon2.3b980430.png";